var codeblock_default = {
  "blockStyleSpacing": "TPUvP",
  "codeBlock": "FNyc6 TPUvP",
  "renderedInTable": "TFibM"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
